import axios from "@/api";

export default {
  namespaced: true,
  state: {
    partners: {
      partners: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0,
        prev: null,
        next: null,
      },
    },
    currentPage: 1,
    partner_users: {
      partner_user: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0,
        prev: null,
        next: null,
      },
    },
    zones: {
      zones: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0,
        prev: null,
        next: null,
      },
    },
    config: {
      routes: {
        billing: {
          enable: false,
          type: "FIXED",
        },
      },
    },
  },
  getters: {},
  mutations: {
    SET_PARTNERS(state, payload) {
      state.partners = payload;
    },
    SET_CURRENT_PAGE(state, payload) {
      state.currentPage = payload;
    },
    SET_PARTNER_USERS(state, payload) {
      state.partner_users = payload;
    },
    SET_PARTNER_CONFIG(state, payload) {
      state.config = payload;
    },
  },
  actions: {
    getPartners({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get("/admin/partners/", { params: payload })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    fetchPartners({ commit }, payload) {
      if (payload.page) {
        commit("SET_CURRENT_PAGE", payload.page);
      }
      if (payload.limit != 10000) {
      } else {
        payload.limit = 10000;
      }
      return new Promise((resolve, reject) => {
        axios
          .get("/admin/partners/", { params: payload })
          .then((response) => {
            commit("SET_PARTNERS", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    storePartner({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("/admin/partners/", payload)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    getPartner({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get("/admin/partners/" + payload.id + "/")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    updatePartner({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = "/admin/partners/" + payload.id + "/";
        delete payload.id;
        axios
          .put(url, payload)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    deletePartner({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete("/admin/partners/" + payload.id + "/")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },

    getPartnerZones({ commit }, payload) {
      return new Promise((resolve, reject) => {
        delete payload.partner_id;
        axios
          .get(`/admin/partners/zones/`, { params: payload })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    downloadQrCodes({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = `/admin/partners/zones/${payload.zone_id}/users/download/`;
        delete payload.zone_id;
        axios
          .post(url, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    fetchPartnerUsers({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = `/admin/partners/zones/${payload.zone_id}/users/`;
        delete payload.zone_id;
        delete payload.partner_id;
        axios
          .get(url, { params: payload })
          .then((response) => {
            commit("SET_PARTNER_USERS", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    partnerCodeConfig({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = `/admin/partners/config/code/`;
        axios
          .get(url)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    downloadPartnerUsers({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = `/admin/partners/report/?export=true`;
        axios
          .get(url, { params: payload })
          .then((response) => {
            //commit('SET_PARTNER_USERS', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject("ERICK_ERROR", error.response);
          });
      });
    },
    MassLoadUsers({ commit }, formData) {
      return new Promise((resolve, reject) => {
        console.log(formData);
        axios
          .post("/admin/partners/import/massive/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("ERROR", error.response);
            reject(error.response);
          });
      });
    },
    CheckUsersProgress({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            "/admin/partners/import/massive/" + payload.task_id + "/progress/"
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("ERROR", error.response);
            reject(error.response);
          });
      });
    },
    UsersActivate({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = "/admin/partners/customer/" + payload.id + "/is-active/";
        let is_active = { is_active: !payload.is_active };
        axios
          .put(url, is_active)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    DeletedIDS({ commit }, payload) {
      return new Promise((resolve, reject) => {
        console.log("payloadEraser", payload);
        let url = "/admin/partners/erase/massive/ids/";
        //axios.delete('/admin/partners/erase/massive/ids/',payload,{headers: { 'Content-Type': '' })
        axios
          .delete(url, {
            data: { ids: payload.ids },
            headers: { "Content-Type": "application/json" },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    DeletedCSV({ commit }, formData) {
      return new Promise((resolve, reject) => {
        console.log(formData);
        let url = "/admin/partners/erase/massive/";
        axios
          .delete(url, {
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    DeletedUsersProgress({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            "/admin/partners/erase/massive/" + payload.task_id + "/progress/"
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    storePartnerUser({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const customFieldsData = payload.custom_fields.reduce(
          (acc, field, index) => {
            acc[index] = field;
            return acc;
          },
          {}
        );

        const data = {
          name: payload.name && payload.name.trim() !== "" ? payload.name : "",
          unlock_code: payload.unlock_code,
          code: payload.code,
          phone:
            payload.phone && payload.phone.trim() !== "" ? payload.phone : "",
          email:
            payload.email && payload.email.trim() !== "" ? payload.email : "",
          custom_fields: customFieldsData,
        };

        let url = `/admin/partners/zones/${payload.zone_id}/users/`;

        axios
          .post(url, data)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    deletePartnerUser({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = `/admin/partners/zones/${payload.zone_id}/users/${payload.id}/`;
        axios
          .delete(url)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    getPartnerUser({ commit }, id) {
      return new Promise((resolve, reject) => {
        let url = `/admin/partners/user/${id}/`;
        axios
          .get(url)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    updatePartnerUser({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const customFieldsData = payload.custom_fields.reduce(
          (acc, field, index) => {
            acc[index] = field;
            return acc;
          },
          {}
        );

        const data = {
          name: payload.name && payload.name.trim() !== "" ? payload.name : "",
          phone:
            payload.phone && payload.phone.trim() !== "" ? payload.phone : "",
          email:
            payload.email && payload.email.trim() !== "" ? payload.email : "",
          custom_fields: customFieldsData,
        };

        let url = `/admin/partners/user/${payload.id}/`;
        axios
          .put(url, data)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    getTripReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = `/admin/reports/trips/`;
        axios
          .get(url, { params: payload })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    downloadTripReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = `/admin/reports/trips/`;
        axios
          .get(url, { params: payload })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    getCodesReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = `/admin/reports/checkins_failed/`;
        axios
          .get(url, { params: payload })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    downloadCodesReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = `/admin/reports/checkins_failed/`;
        axios
          .get(url, { params: payload })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    getPassengerReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = `/admin/reports/checkin/`;
        axios
          .get(url, { params: payload })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    downloadPassengerReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        let url = `/admin/reports/checkin/`;
        axios
          .get(url, { params: payload })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    fetchDriversReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin/reports/drivers/`, { params: payload })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchDriverTripsReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin/reports/drivers/${payload.id}/`, { params: payload })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchRoutesReport({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin/reports/routes/`, { params: payload })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchRoutesReportWeekly({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin/reports/routes/mabe/`, {
            params: payload,
            headers: {
              responseType: "blob",
            },
            responseType: "blob",
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getConfig({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get("/admin/partners/config/")
          .then((response) => {
            commit("SET_PARTNER_CONFIG", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
  },
};
